'use strict'

export default function (): void {
  const el = document.getElementById('modify-filters')

  if (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      const filterList = document.getElementById('search-filters-on-offers')

      if (filterList?.classList.contains('search__availabilities--opened')) {
        filterList?.classList.remove('search__availabilities--opened')
      } else {
        filterList?.classList.add('search__availabilities--opened')
      }
    })
  }
}
